import api from '@api'
import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import Form from '@blocks/Form'
import Grid from '@blocks/Grid'
import Input from '@blocks/Input'
import Select from '@blocks/Select'
import { notify } from '@helpers'
import useCountries from '@hooks/models/useCountries'
import useAuth from '@hooks/useAuth'
import useTitle from '@hooks/useTitle'
import MainContainer from '@blocks/MainContainer'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import EmphasizedContent from '@blocks/EmphasizedContent'

export default function SettingsPage() {
    useTitle("Past")
    useMainTemplate({ category: "settings" })

    const { user, setUser, destroy } = useAuth<Resources.Customer>()
    const { country, options: countries } = useCountries(user.country.id)

    const handleUpdateSuccess = (user: Resources.Customer) => {
        notify("We succesfully updated the information!")
        setUser(user)
    }

    const handlePasswordSuccess = (data: never, form: HTMLFormElement) => {
        notify("We succesfully updated the password!")
        form.reset()
    }

    return (
        <MainContainer heading="Settings">
            <Grid>
                <Form action={api.settings} handleSuccess={handleUpdateSuccess} method="patch">
                    <Grid gap="20px">
                        <div>
                            <h2 className="h4">Account</h2>
                            <hr />
                        </div>
                        <Grid columns="3" gap="30px|60px">
                            <Grid gap="20px">
                                <div>
                                    <h3>Personal</h3>
                                    <p>All the information must be written in English. Otherwise, FIAP and PSA will not accept it.</p>
                                </div>
                                <Grid gap="20px">
                                    <Input
                                        id="first_name"
                                        name="first_name"
                                        pattern="^([A-Z][a-zA-Z \-]+|[A-Z])$"
                                        title="Only latin letters and the first letter must be in uppercase."
                                        label="First name"
                                        placeholder="John"
                                        defaultValue={user.first_name}
                                        autoFocus
                                        required />
                                    <Input
                                        id="last_name"
                                        name="last_name"
                                        pattern="^([A-Z][a-zA-Z \-]+|[A-Z])$"
                                        title="Only latin letters and the first letter must be in upper case."
                                        defaultValue={user.last_name}
                                        label="Last name"
                                        placeholder="Doe"
                                        required />
                                </Grid>
                            </Grid>
                            <Grid gap="20px">
                                <div>
                                    <h3>Postal address</h3>
                                    <p>Please, enter your address correctly as it will be used for awards/catalogues delivery.</p>
                                </div>
                                <Grid gap="20px">
                                    <Select id="country_id" name="country_id" label="Country" value={country} options={countries} placeholder="Select" required />
                                    <Input id="address" name="address" label="Full address" defaultValue={user.address} placeholder="France, Paris, 92 Place de la Madeleine" required />
                                    <Input id="zip" name="zip" label="ZIP Code" defaultValue={user.zip} placeholder="75011" required />
                                    <hr />
                                    <Input id="phone" name="phone" type="tel" label="Phone" defaultValue={user.phone || undefined} placeholder="+33 1 09 75 83 51" comment="We will never call you or send spam. The phone will be given to the postal company in order to deliver your package faster. It's not required to provide it." />
                                </Grid>
                            </Grid>
                            <Grid gap="20px">
                                <div>
                                    <h3>Email</h3>
                                    <p>Please, set the actual email. We use it for notifications regarding salons you participate.</p>
                                </div>
                                <Input
                                    id="email"
                                    name="email"
                                    type="email"
                                    defaultValue={user.email}
                                    label="Email"
                                    placeholder="email@example.com"
                                    required />
                            </Grid>
                        </Grid>
                        <Flex justifyContent="flex-end" width="100%"><Button element="submit" width="fixed">Save</Button></Flex>
                    </Grid>
                </Form>
                <Grid gap="20px">
                    <div>
                        <h2 className="h4">Password</h2>
                        <hr />
                    </div>
                    <Form action={api.password} handleSuccess={handlePasswordSuccess} method="patch">
                        <Grid columns="3">
                            <Grid gap="20px">
                                <Input minLength={8} id="password_old" name="password_old" height="l" type="password" placeholder="xxxxxxxx" label="Old Password" required />
                                <Input minLength={8} id="password" name="password" height="l" type="password" placeholder="xxxxxxxx" label="Password" required />
                                <Input minLength={8} id="password_confirmation" height="l" name="password_confirmation" type="password" placeholder="xxxxxxxx" label="Repeat password" required />
                                <Button element="submit">Save</Button>
                            </Grid>
                        </Grid>
                    </Form>
                </Grid>
                {user.deletable && (
                    <Grid gap="10px">
                        <div>
                            <h2 className="h4">Data</h2>
                            <hr />
                        </div>
                        <Grid columns="3">
                            <EmphasizedContent>
                                <Grid gap="15px">
                                    <p>This button deletes the account and the data associated with it. Be catious, the action is irreversible.</p>
                                    <Button type="tertiary" width="auto" onClick={destroy}>Delete</Button>
                                </Grid>
                            </EmphasizedContent>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </MainContainer>
    )
}